import { required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ErrorList from "./ErrorList"
import {stepsConstants} from "../../data/steps";

export default {
  props: ['formData', 'formOptions', 'formLabels'],
  components: {
    ErrorList
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      formData: {
        occupationOther: {
          required: helpers.withMessage(stepsConstants.please_fill_radio_group, required),
        },
        workingAs: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, (value, siblings) => {
            return (siblings.occupationOther === stepsConstants.i_am_voluntary_insured && value) || siblings.occupationOther !== stepsConstants.i_am_voluntary_insured
          })
        }
      }
    }
  },
  computed: {
    showWorkingAsField () {
      return this.formData.occupationOther === stepsConstants.i_am_voluntary_insured;
    }
  },
  methods: {
    onOccupationOtherChanged(e) {
      if(e.target.value !== stepsConstants.i_am_voluntary_insured) {
        this.formData.workingAs = ''
      } else {
        if (this.$refs.workingAsField) {
          this.$refs.workingAsField.focus()
          this.$refs.workingAsField.scrollIntoView({ behavior: "smooth"})
        }
      }
    },
    setErrorId(fieldName) {
      const errors = this.v$.formData[fieldName].$errors
      return errors.length ? `errors--${fieldName}` : null
    }
  },
  template: `
    <div class="application__fields__input-group">
        <div class="form__title"></div>

        <div v-for="text in formOptions.occupationOther" class="form__radio-outer">
            <label class="form__label">
                <input :aria-describedby="setErrorId('occupationOther')" type="radio" v-model="formData.occupationOther" name="occupationOther" :value="text" @change="onOccupationOtherChanged" required>
                {{text}}
            </label>
        </div>
        <error-list :errors="v$.formData.occupationOther.$errors" :id="setErrorId('occupationOther')"/>
    </div>
    <div v-show="showWorkingAsField" class="application__fields__input-group" style="margin-top: 50px;">
        <label for="workingAs" class="form__label">...und arbeite als<span class="form__mandatory">*</span></label>
        <input :aria-describedby="setErrorId('workingAs')" type="text" v-model="formData.workingAs" name="workingAs" id="workingAs" class="form__input" placeholder="z.B.: Künstler, Journalist, etc." ref="workingAsField">
        <error-list :errors="v$.formData.workingAs.$errors" :id="setErrorId('workingAs')"/>
    </div>
    `
}
